import axios from '@/plugin/axios';

/**
 * Send report data to backend
 * @param {{id: string|number, data: object}} report
 * @returns {Promise<object>}
 */
const submitReport = ({ id, data }) =>
  new Promise((resolve, reject) => {
    axios
      .post(`/organizations/${id}/submit_yearly_report/`, data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Retrieves report by id
 * @param {string|number} id
 * @returns {Promise<object>}
 */
const getReports = (id) =>
  new Promise((resolve, reject) => {
    axios
      .get(`/organizations/${id}/view_yearly_report/`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  submitReport,
  // RegisterOrgainisation,
  getReports,
};
